<h2 class="d-flex justify-content-between uppercase">
  <span mat-dialog-title>
    {{ multilingualService.langMap?.LABEL_MORE_SETTINGS_ACCOUNT_PROFILE }}
  </span>
  @if (data || showError) {
    <button
      mat-dialog-close
      class="close"
      mat-icon-button
      [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
    >
      <mat-icon class="icon-cross"></mat-icon>
    </button>
  }
</h2>
<mat-dialog-content class="mat-typography">
  @if (!showError) {
    <div class="form-content mt-2 form-width">
      <p class="title-10">
        {{ multilingualService.langMap?.UPDATE_PROFILE_INFO_MSG }}
      </p>
      <form [formGroup]="userForm">
        <div class="mb-2">
          <div class="form-group mb-2">
            <label for="email_input">
              {{ multilingualService.langMap?.LABEL_REGISTRATION_FORM_EMAIL }}
              <span class="input-required text-w-600">*</span>
            </label>
            <input
              id="email_input"
              formControlName="email"
              type="text"
              class="form-control"
              (keyup)="checkEmailUpdateEvent()"
            />
            @if (userForm.get('email')?.errors?.required && userForm.get('email')?.touched) {
              <span role="alert" class="text-danger">
                {{ multilingualService.langMap?.MESSAGE_ENTER_EMAIL }}
              </span>
            }
            @if (userForm.get('email')?.errors?.pattern && userForm.get('email')?.touched) {
              <span role="alert" class="text-danger">
                {{ multilingualService.langMap?.MESSAGE_ENTER_VALID_EMAIL }}
              </span>
            }
          </div>
          @if (emailUpdate) {
            @if (resendOtp) {
              <div class="form-group mb-2">
                <label for="otp_input">
                  {{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_FORM_VERIFICATION_CODE }}
                  <span class="input-required text-w-600">*</span>
                </label>
                <input
                  id="otp_input"
                  [(ngModel)]="otpValue"
                  [ngModelOptions]="{ standalone: true }"
                  type="text"
                  class="form-control"
                  (keypress)="checkIfSpace($event)"
                  [disabled]="!resendOtp"
                  maxlength="6"
                />
              </div>
            }
            @if (!otpVerified) {
              <div class="button-group center">
                @if (!resendOtp) {
                  <button
                    mat-raised-button
                    class="primary-button uppercase"
                    (click)="sendVerificationCode(true)"
                    [disabled]="resendOtp || userForm.get('email')?.invalid"
                  >
                    {{ multilingualService.langMap?.BUTTON_UPDATE_PROFILE_SEND_VERIFICATION_CODE }}
                  </button>
                }
                @if (resendOtp) {
                  <div class="d-flex justify-content-between full-width">
                    <button
                      mat-raised-button
                      class="primary-button uppercase full-width mr-1"
                      (click)="verifyCode()"
                      [disabled]="checkOtpLength() || otpVerified"
                    >
                      {{ multilingualService.langMap?.BUTTON_UPDATE_PROFILE_VERIFY_CODE }}
                    </button>
                    <button
                      mat-raised-button
                      class="primary-button uppercase full-width send-code"
                      (click)="sendVerificationCode(false)"
                      [disabled]="!resendOtp"
                    >
                      {{ multilingualService.langMap?.BUTTON_UPDATE_PROFILE_SEND_AGAIN }}
                    </button>
                  </div>
                }
              </div>
            }
          }
        </div>
        <div class="form-group mb-2" style="position: relative">
          <label for="contact_input">
            {{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_FORM_CONTACT_NUMBER }}
            <span class="input-required text-w-600">*</span>
          </label>
          <input
            readonly="true"
            class="country-code form-control"
            type="text"
            value="+1"
            style="width: 12%"
          />
          <input
            id="contact_input"
            formControlName="contact"
            type="text"
            class="form-control number-input"
            (keypress)="checkIfSpace($event)"
            maxlength="10"
          />
          @if (userForm.get('contact')?.errors?.required && userForm.get('contact')?.touched) {
            <span role="alert" class="text-danger">
              {{ multilingualService.langMap?.ERROR_MSG_MOBILE_NUMBER_IMP }}
            </span>
          }
          @if (
            (userForm.get('contact')?.errors?.minlength ||
              userForm.get('contact')?.errors?.maxlength) &&
            userForm.get('contact')?.touched
          ) {
            <span role="alert" class="text-danger">
              {{ multilingualService.langMap?.ERROR_MSG_MOBILE_NUMBER_VALIDATION_DIGITS }}
            </span>
          }
        </div>
        <div class="form-group mb-2">
          <label for="firstName_value">
            {{ multilingualService.langMap?.LABEL_REGISTRATION_FORM_FIRST_NAME }}
          </label>
          <p id="firstName_value" class="text-w-700">
            {{ userForm.get('firstName')?.value }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="lastName_value">
            {{ multilingualService.langMap?.LABEL_REGISTRATION_FORM_LAST_NAME }}
          </label>
          <p id="lastName_value" class="text-w-700">
            {{ userForm.get('lastName')?.value }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="DOB_value">
            {{ multilingualService.langMap?.LABEL_MEMBERSHIP_DETAILS_DOB }} (MM-DD-YYYY)
          </label>
          <p id="DOB_value" class="text-w-700">
            {{ userForm.get('dob')?.value | date: 'MM-dd-yyy' }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="card_id_value">
            {{ multilingualService.langMap?.LABEL_COMMON_CARD_ID }}
          </label>
          <p id="card_id_value" class="text-w-700">
            {{ userForm.get('cardId')?.value }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="rx_grp_value">
            {{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_FORM_RXGRP }}
          </label>
          <p id="rx_grp_value" class="text-w-700">
            {{ userForm.get('rxGrp')?.value }}
          </p>
        </div>
      </form>
    </div>
  }
  @if (showError) {
    <div class="empty-box-height auto-margin flex-column">
      <img
        aria-hidden="true"
        imageName="something-went-wrong.svg"
        alt="Something went wrong"
        width="75px"
      />
      <p role="alert" class="title-11 text-w-700 mt-1">
        {{ multilingualService.langMap?.ERROR_COMMON_SOMETHING_WENT_WRONG }}
      </p>
    </div>
  }
</mat-dialog-content>

@if (!showError) {
  <div class="bottom-btn justify-content-center mat-dialog-actions">
    @if (!isLoading && !userService.isMemberTermed()) {
      <button
        [disabled]="userForm.invalid || !otpVerified"
        (click)="update()"
        mat-raised-button
        class="primary-button uppercase"
      >
        {{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_SUBMIT }}
      </button>
    }
    @if (isLoading) {
      <button mat-raised-button class="primary-button uppercase button-loader">
        <span>
          <img imageName="small-loader.gif" [common]="true" alt="loader" width="25px" />
        </span>
      </button>
    }
  </div>
}

<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{ errorMsg }}</span>
  </div>
</ng-template>
<ng-template #success>
  <div class="toaster-bg success d-flex justify-content-center">
    <mat-icon class="icon-success mr-1"></mat-icon>
    <span>{{ successMsg }}</span>
  </div>
</ng-template>
